import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InputModule } from '@rappi/ui/input';
import { SelectModule } from '@rappi/ui/select';
import { CardModule } from '@rappi/ui/card';
import { FormErrorsDirectiveModule } from '@rappi/common';

import { CampaignTroubleshootingRoutingModule } from './campaign-troubleshooting-routing.module';
import { DiagnosticService } from './services/diagnostic.service';

import { CampaignTroubleshootingComponent } from './components/campaign-troubleshooting/campaign-troubleshooting.component';
import { DiagnosticFormComponent } from './components/diagnostic-form/diagnostic-form.component';
import { EarlyExitCardComponent } from './components/early-exit-card/early-exit-card.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CampaignTroubleshootingRoutingModule,
    MatProgressBarModule,
    InputModule,
    SelectModule,
    CardModule,
    FormErrorsDirectiveModule
  ],
  declarations: [
    CampaignTroubleshootingComponent,
    DiagnosticFormComponent,
    EarlyExitCardComponent
  ],
  providers: [DiagnosticService]
})
export class CampaignTroubleshootingModule {}
